import { PageHeading } from "@/components/Layout/Parts";
import Text from "@/components/Text";

import ProjectsTable from "./components/ProjectsTable";

const GamificationProjects = () => {
  return (
    <>
      <Text $type="caption" $color="gray">
        ALL TEAMS
      </Text>
      <PageHeading>Competitions</PageHeading>
      <ProjectsTable />
    </>
  );
};

export default GamificationProjects;
